import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth-context.js';
import { useOrg } from '../lib/org-context.js';
import { apiFetch } from '../lib/api.js';

export function ImpersonationBanner() {
  const { isImpersonating, stopImpersonation, impersonationSessionId } = useAuth();
  const { viewingOrgName, deselectOrg } = useOrg();
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  if (!isImpersonating) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      if (impersonationSessionId) {
        await apiFetch('/admin/stop-impersonate', {
          method: 'POST',
          body: JSON.stringify({ session_id: impersonationSessionId }),
        });
      }
    } catch {
      // Best-effort — proceed with local cleanup even if API fails
    }
    stopImpersonation();
    deselectOrg();
    setExiting(false);
    navigate('/admin/orgs');
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 text-sm flex items-center justify-center gap-3 z-50">
      <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>
        You are viewing as <strong>{viewingOrgName ?? 'unknown org'}</strong> admin
      </span>
      <button
        onClick={handleExit}
        disabled={exiting}
        className="ml-2 bg-amber-700 hover:bg-amber-800 text-white text-xs font-medium px-3 py-1 rounded-lg transition-colors disabled:opacity-50"
      >
        {exiting ? 'Exiting...' : 'Exit Impersonation'}
      </button>
    </div>
  );
}
